import { initContract } from "@ts-rest/core";
import z from "zod";

import {
  applicationTypeEnumSchema,
  eligibilityResultsSchema,
  eligibilityResultWithMemberNameSchema,
  insertEligibilityResultSchema,
} from "@libs/db-schemas";

import { HTTPStatusCode } from "../../types";
import { errorSchema } from "../../utils/errors";

const c = initContract();

export const eligibilityResultsContract = c.router({
  syncEligibilityResults: {
    path: "/eligibility-results/:householdId/sync",
    summary: "Sync eligibility results for a household (delete all + recreate)",
    method: "PUT",
    pathParams: z.object({
      householdId: z.uuid(),
    }),
    body: z.object({
      eligibilityResults: z.array(
        insertEligibilityResultSchema.omit({
          id: true,
          householdId: true,
        }),
      ),
    }),
    responses: {
      [HTTPStatusCode.OK]: z.array(eligibilityResultsSchema),
      [HTTPStatusCode.UNAUTHORIZED]: errorSchema,
    },
  },
  listEligibilityResults: {
    summary: "Get a list of eligibility results",
    method: "GET",
    path: "/eligibility-results/",
    query: z.object({
      applicationType: applicationTypeEnumSchema.optional(),
      householdMemberId: z.uuid().optional(),
    }),
    responses: {
      [HTTPStatusCode.OK]: z.array(eligibilityResultWithMemberNameSchema),
      [HTTPStatusCode.NOT_FOUND]: errorSchema,
    },
  },
});
